






import { defineComponent, ref } from "@nuxtjs/composition-api";
import { json2html } from "html2json_2";
import PBComponent from "~/components/PageBuilder/utils/component";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "ElementsHtmlCode",
  components: {
    ...loadAsyncComponent(),
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const htmlContent = ref("");
    if (props.children) {
      props.children.forEach((item) => {
        htmlContent.value += json2html(item);
      });
    }

    return {
      htmlContent,
    };
  },
});
